import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';

export function updatePayoutManually({
    bookingId,
    userType,
    updateLoaderState
}) {
    return async (dispatch, getState, { client }) => {
        try {
            let errorMessage = 'Oops! something went wrong. Try again!';

            const mutation = gql`
        mutation updatePayoutManually (
            $userType: String!
            $bookingId: Int!
          ) {
            updatePayoutManually (
              userType: $userType
              bookingId: $bookingId
            ) {
              status
              errorMessage
            }
          }
            `;

            if (updateLoaderState) updateLoaderState({ type: 'addPayout', userType, value: bookingId });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    userType,
                },
            });

            if (data && data.updatePayoutManually && data.updatePayoutManually.status === 200) {
                toastr.success('Success!', 'Payout status has been updated!');
                if (updateLoaderState) updateLoaderState({ type: 'successPayout', userType, value: bookingId });

            } else {
                errorMessage = (data && data.updatePayoutManually && data.updatePayoutManually.errorMessage) ? data.updatePayoutManually.errorMessage : errorMessage;
                toastr.error("Error!", errorMessage);
            }
            if (updateLoaderState) updateLoaderState({ type: 'removePayout', userType, value: bookingId });

        } catch (error) {
            if (updateLoaderState) updateLoaderState({ type: 'removePayout', userType, value: bookingId });
            toastr.error("Error!", 'Oops! something went wrong. ' + error.message);
        }

    }
}